'use client';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslations } from 'next-intl';

import ClutchWidget from '@/components/ClutchWidget';
import { verifiedLinkPlatforms } from '@/config/profiles.config';
import colors from '@/styles/themes/colors';

import styles from './BrandCard.module.scss';
import CaseStudyShowcase, { ShowcaseItem } from './CaseStudyShowcase';

interface BrandCardProps {
  items: ShowcaseItem[];
}

const BrandCard = ({ items }: BrandCardProps) => {
  const t = useTranslations('common');

  return (
    <Box className={styles.brandCard}>
      <Stack className={styles.content} spacing={3}>
        <Typography variant="h5" component="p" color={colors.white} className={styles.title}>
          {t('footer.brandCard.title')}
        </Typography>
        <ClutchWidget variant="footer" />
        {/* Follow links required by platform verification, so no rel="nofollow" */}
        {verifiedLinkPlatforms.map(({ name, profileUrl }) => (
          <Typography
            key={name}
            component="a"
            variant="body2"
            color={colors.graytone300}
            href={profileUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.verifiedLink}
          >
            {t('footer.brandCard.verifiedOn', { platform: name })}
          </Typography>
        ))}
      </Stack>
      <Box className={styles.showcaseSlot}>
        <CaseStudyShowcase items={items} />
      </Box>
    </Box>
  );
};

export default BrandCard;
